(() => {
  const clamp = (value, min = 0, max = 1) => {
    return Math.min(Math.max(value, min), max);
  };

  const easeOutCubic = (value) => {
    return 1 - Math.pow(1 - value, 3);
  };

  const prefersReducedMotion = () => {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  const isMobile = () => {
    return window.matchMedia('(max-width: 1023px)').matches;
  };

  const initScrollImageGrid = (section) => {
    if (section.dataset.scrollImageGridInitialized === 'true') return;
    section.dataset.scrollImageGridInitialized = 'true';

    const items = Array.from(section.querySelectorAll('[data-scroll-image-grid-item]'));
    if (!items.length) return;

    const rowStartStep = 0.5;
    const rowDuration = 1;

    const getTimelineIndex = (item) => {
      if (isMobile()) {
        return Number(item.dataset.itemIndex || 0);
      }

      return Number(item.dataset.rowIndex || 0);
    };

    const getTotalTimelineItems = () => {
      if (isMobile()) {
        return items.length;
      }

      const rowIndexes = items.map((item) => {
        return Number(item.dataset.rowIndex || 0);
      });

      return Math.max(...rowIndexes) + 1;
    };

    const setAllComplete = () => {
      items.forEach((item) => {
        item.style.setProperty('--sig-item-progress', '1');
      });
    };

    const update = () => {
      if (prefersReducedMotion()) {
        setAllComplete();
        return;
      }

      const totalTimelineItems = getTotalTimelineItems();
      const totalTimelineUnits = Math.max(1, (totalTimelineItems - 1) * rowStartStep + rowDuration);

      const rect = section.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      const start = viewportHeight * 0.9;
      const end = viewportHeight * 0.25;
      const scrollRange = start - end;

      const rawProgress = (start - rect.top) / scrollRange;
      const sectionProgress = clamp(rawProgress);
      const timelineProgress = sectionProgress * totalTimelineUnits;

      items.forEach((item) => {
        const timelineIndex = getTimelineIndex(item);
        const itemStart = timelineIndex * rowStartStep;
        const rawItemProgress = clamp((timelineProgress - itemStart) / rowDuration);
        const easedProgress = easeOutCubic(rawItemProgress);

        item.style.setProperty('--sig-item-progress', easedProgress.toFixed(4));
      });
    };

    let ticking = false;

    const requestUpdate = () => {
      if (ticking) return;

      ticking = true;

      window.requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    };

    update();

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(section)) return;

      window.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', requestUpdate);
    });
  };

  const initAllScrollImageGrids = () => {
    document.querySelectorAll('[data-scroll-image-grid]').forEach(initScrollImageGrid);
  };

  document.addEventListener('DOMContentLoaded', initAllScrollImageGrids);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-scroll-image-grid]');
    if (section) initScrollImageGrid(section);
  });
})();